import { IoIosArrowBack } from "react-icons/io";
import img1 from "../../assets/dashboard/weblog/joyce-adams-eF_3z15RmWY-unsplash.png";
import { BsFillClockFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import "../style/dashboard/Weblog.css";

let weblog_data = [
  {
    id: 1,
    title: "آیا عصر دایناسور های به پایان رسیده؟",
    img: img1,
    subtitle:
      "به نظر شما زمان آن نرسیده که از خود این سوال را بپرسیم چرا دایناسورها رامنقرض کردیم؟",
    badge: "برچسب",
    reading_time: 5,
  },
  {
    id: 2,
    title: "سرنوشت ببر مازندران چه شد؟",
    img: "",
    subtitle:
      "به نظر شما زمان آن نرسیده که از خود این سوال را بپرسیم چرا دایناسورها رامنقرض کردیم؟",
    badge: "برچسب",
    reading_time: 4,
  },
];

const Weblog = () => {
  return (
    <div className="weblog">
      <div className="weblog-title-box">
        <div className="weblog-title">از وبلاگ</div>
        <div className="weblog-btn-container">
          <div className="weblog-btn">
            <IoIosArrowBack className="weblog-btn-icon" />
            <Link to="/dashboard/blog" className="weblog-btn-text">
              رفتن به وبلاگ
            </Link>
          </div>
        </div>
      </div>
      <div className="weblog-content">
        {weblog_data.map((item) => (
          <div key={item.id} className="wc-item">
            {item.img && (
              <div className="wc-item-img-container">
                <img src={item.img} alt="item-img" />
              </div>
            )}
            <div className="wc-item-description">
              <div className="wc-item-description-title">{item.title}</div>
              <div className="wc-item-description-subtitle">
                {item.subtitle}
              </div>
            </div>
            <div className="wc-item-badge">{item.badge}</div>
            <div className="wc-item-reading-time">
              <BsFillClockFill className="wc-item-reading-time-icon" />
              زمان مطالعه {item.reading_time} دقیقه
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Weblog;
